import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function getContentBundles(
  bundlesIDs: any[],
  include_product: boolean
) {
  // Check if all IDs are numbers or numeric strings that can be converted to integers
  const isNumericArray = bundlesIDs.every(
    (id) =>
      typeof id === "number" ||
      (typeof id === "string" &&
        !isNaN(Number(id)) &&
        Number.isInteger(Number(id)))
  );

  const processedBundleIDs = isNumericArray
    ? bundlesIDs.map((id) => Number(id))
    : bundlesIDs.map((id) => String(id));

  const { data } = await unauthenticatedHttp().post(
    `${window.env.API_UNAUTH}/get-content-catalog-bundle`,
    {
      content_bundle_id: processedBundleIDs,
      include_product,
    }
  );
  return data;
}
